import React from "react";
import { AgGridReact, AgGridReactProps, AgReactUiProps } from "ag-grid-react";
import Config from "../../config/Config";
import "ag-grid-enterprise";
import { useAppDispatch } from "../../store/app";

interface AgGridWrapperProps extends AgReactUiProps, AgGridReactProps {
  type?: "serverSide" | "clientSide";
  onGridReadyWithDispatch?: any;
  onSwitchChangeGrid?: any;
  gridConfig?: any;
  pinnedBottomRowDataRow?: []
}

const AgGridWrapper: React.FC<AgGridWrapperProps> = ({
  children,
  type = "clientSide",
  context,
  onGridReadyWithDispatch,
  onSwitchChangeGrid,
  pinnedBottomRowDataRow = [],
  gridConfig,
  ...rest
}) => {
  var gridType: any;
  if (gridConfig) {
    gridType = gridConfig
  } else {
    gridType = type === "serverSide" ? Config.grid.server : Config.grid.local;
  }
  const dispatch = useAppDispatch();

  return (
    <div className="ag-theme-alpine ag-grid-wrapper">
      <AgGridReact
        {...gridType}
        // {...(type === "serverSide"
        //   ? {
        //       onGridReady: (params: any) =>
        //         dispatch(onGridReadyWithDispatch(params)).catch(
        //           (error: any) => error
        //         ),
        //     }
        //   : {})}
        onGridReady={(params: any) => dispatch(onGridReadyWithDispatch(params))}
        onSwitchChangeGrid={onSwitchChangeGrid}
        suppressExcelExport={true}
        suppressCsvExport={true}
        pinnedBottomRowData={pinnedBottomRowDataRow}
        context={
          context && {
            // dispatch,
            ...context,
          }
        }
        {...rest as any}
      >
        {children}
      </AgGridReact>
    </div>
  );
};

export default AgGridWrapper;
